export const AUTH_TOKEN = 'token';
export const ACCESS_TYPE = 'accessType';
